import { useState, useEffect, useCallback } from 'react';

export const useNotifications = () => {
  const [permission, setPermission] = useState('granted'); // Always enabled for modal notifications
  const [isSupported] = useState(true); // Always supported since we use modal
  const [modalNotification, setModalNotification] = useState(null);


  const requestPermission = useCallback(async () => {
    // For modal notifications, we don't need browser permission
    // Just return true to indicate success
    setPermission('granted');
    return true;
  }, []);

  const showModalNotification = useCallback((notificationData) => {
    console.log('showModalNotification called with:', notificationData);
    setModalNotification(notificationData);
    console.log('Modal notification state should be set');
  }, []); // Remove modalNotification dependency

  const hideModalNotification = useCallback(() => {
    setModalNotification(null);
  }, []);

  const showActionsReadyNotification = useCallback((job) => {
    const actionCount = job.action_count || 0;
    
    if (actionCount > 0) {
      showModalNotification({
        jobId: job.id,
        url: job.url,
        actionCount: actionCount,
        type: 'actions_ready'
      });
    }
  }, [showModalNotification]);

  // Legacy methods - kept for compatibility but do nothing
  const showJobCompleteNotification = useCallback(() => {
    // No longer used - we only show modal for actions ready
    return null;
  }, []);

  const showActionGenerationNotification = useCallback(() => {
    // No longer used - we only show modal for actions ready
    return null;
  }, []);

  const showNotification = useCallback(() => {
    // No longer used - we only show modal for actions ready
    return null;
  }, []);

  // Test function - remove in production
  const testNotification = useCallback(() => {
    console.log('Testing notification modal...');
    showModalNotification({
      jobId: 'test-job-123',
      url: 'https://example.com',
      actionCount: 8,
      type: 'actions_ready'
    });
  }, [showModalNotification]);

  // Make test function available globally after component mounts
  useEffect(() => {
    window.testNotificationModal = testNotification;
    
    return () => {
      delete window.testNotificationModal;
    };
  }, [testNotification]);

  return {
    isSupported,
    permission,
    requestPermission,
    showNotification,
    showJobCompleteNotification,
    showActionGenerationNotification,
    showActionsReadyNotification,
    modalNotification,
    hideModalNotification,
    testNotification
  };
}